import styled from "styled-components"

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 1025px) {
    display: none;
  }

  .grid-container {
    padding-top: 12px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 7px;
    margin: auto;
    justify-items: center;
  }

  .card-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .card {
    border-radius: 50%;
    width: 70px;
    height: 70px;
    margin: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }

  .img {
    height: 50px;
    width: 50px;
  }

  .card-label {
    color: #ffff;
    text-align: center;
    font-size: 9px;
    white-space : nowrap;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  h4,
  p {
    text-align: center;
    font-size: 80%;
    color: black;
  }
`
